import { createClampBoardZoom, useBoardCanvasViewport } from './useBoardCanvasViewport';

export const clampBoardMapZoom = createClampBoardZoom(0.05, 4);

export const useBoardMapViewport = props =>
  useBoardCanvasViewport({
    ...props,
    clampZoom: clampBoardMapZoom,
  });
